import { render, staticRenderFns } from "./JSelectPosition.vue?vue&type=template&id=cb53a3b8&scoped=true"
import script from "./JSelectPosition.vue?vue&type=script&lang=js"
export * from "./JSelectPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb53a3b8",
  null
  
)

export default component.exports